import { render } from "./InternalReturnRequest.vue?vue&type=template&id=accdd434"
import script from "./InternalReturnRequest.vue?vue&type=script&lang=js"
export * from "./InternalReturnRequest.vue?vue&type=script&lang=js"

import "./InternalReturnRequest.vue?vue&type=style&index=0&id=accdd434&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__